
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-practice-tests",
      function () {
        return require("private-next-pages/ai-practice-tests.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-practice-tests"])
      });
    }
  